import { useState } from 'react'
import styled from 'styled-components'
import { Card } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import RouteContainer from '../../../common/styles/RouteContainer'
import RouteTitle from '../../../common/RouteTitle/RouteTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import RouteTitleConfig from '../../../config/RouteTitleConfig'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import RowSpacer from '../../../common/styles/RowSpacer'
import { BooksitoutServer } from '../../../config/BooksitoutServer'
import useLoginStore from '../../login/useLoginStore'
import useHtmlTitle from '../../../common/useHtmlTitle'

const SettingsWithdrawRoute = () => {
	useHtmlTitle('회원탈퇴')
	const navigate = useNavigate()
	const logout = useLoginStore(state => state.logout)
	const [isProcessing, setIsProcessing] = useState(false)

	const onWithdraw = () => {
		if (!window.confirm('정말로 탈퇴하시겠어요? 모든 데이터가 삭제되며, 이 작업은 되돌릴 수 없어요.')) return
		if (!window.confirm('정말로 탈퇴하시겠어요? 한번 삭제된 데이터는 복구할 수 없어요.')) return

		setIsProcessing(true)
		BooksitoutServer.delete('/v1/users/me')
			.then(() => {
				toast.success('회원탈퇴가 완료되었어요. 그동안 이용해 주셔서 감사해요.')
				logout(false, navigate)
			})
			.catch(() => {
				toast.error('오류가 났어요. 잠시 후 다시 시도해 주세요.')
				setIsProcessing(false)
			})
	}

	return (
		<RouteContainer>
			<RouteTitle icon={<booksitoutIcon.settings />} title={'설정'} currentKey={'main'} buttons={RouteTitleConfig.Settings} />

			<RowSpacer />

			<Card>
				<CardBodyContentContainer>
					<Title>회원탈퇴</Title>
					<RowSpacer size={10} />

					<WarningList>
						<li>탈퇴하시면 등록한 책, 독서활동, 메모 등 모든 데이터가 영구적으로 삭제돼요.</li>
						<li>삭제된 데이터는 복구할 수 없어요.</li>
						<li>같은 계정으로 다시 가입하더라도 이전 데이터를 이용할 수 없어요.</li>
					</WarningList>

					<RowSpacer size={30} />

					<div className="d-flex justify-content-end">
						<WithdrawButton onClick={onWithdraw} disabled={isProcessing}>
							{isProcessing ? '처리 중...' : '회원탈퇴'}
						</WithdrawButton>
					</div>
				</CardBodyContentContainer>
			</Card>

			<RowSpacer />
		</RouteContainer>
	)
}

const Title = styled.h3`
	color: var(--text-color);
`

const WarningList = styled.ul`
	color: var(--sub-text-color);
	line-height: 2;
	padding-left: 20px;
`

const WithdrawButton = styled.button`
	width: 100%;
	max-width: 300px;
	padding: 12px 24px;
	border: none;
	border-radius: 12px;
	background-color: var(--danger);
	color: white;
	font-size: 16px;
	font-weight: bold;
	cursor: pointer;

	&:hover {
		opacity: 0.9;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`

export default SettingsWithdrawRoute
